export default class BaseGatedContent {
    form = null;
    submitButton = null;

    init() {
        this.form = this.$el.querySelector('form');
        this.submitButton = this.form.querySelector('button[type="submit"]');
        const selectField = this.form.querySelector('select[name="job-role"]');

        this.submitButton.disabled = true;

        selectField.addEventListener('change', () => {
            this.toggleSubmitButton(selectField);
        });

        this.form.addEventListener('submit', (e) => {
            e.preventDefault();
            this.submitForm();
        });
    }

    toggleSubmitButton(selectField) {
        if (!selectField.value || selectField.value === "0") {
            this.submitButton.disabled = true;
        } else {
            this.submitButton.disabled = false;
        }
    }

    submitForm() {
        const selectField = this.form.querySelector('select[name="job-role"]');

         // check the form is fully valid
        if (!this.form.checkValidity()) {
            return;
        }

        if (!selectField.value || selectField.value === "0") {
            return;
        }

        // Download the file that has it's url in the selectFields value
        window.location.href = selectField.value;
    }
}

document.addEventListener('alpine:init', () => {
    Alpine.data('gatedContent', () => new BaseGatedContent());
});
